var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mt-2" },
    [
      _c(
        "b-col",
        [
          _vm.contactPersons && _vm.contactPersons.length !== 0
            ? _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c("h4", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.adminUserContactPerson.title")) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      responsive: "",
                      fields: _vm.fields,
                      items: _vm.contactPersons,
                      "tbody-class": "text-muted"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "dateOfBirth",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm
                                    .$moment(row.item.dateOfBirth, "YYYY-MM-DD")
                                    .format("DD.MM.YYYY")
                                ) +
                                "\n        "
                            )
                          ]
                        }
                      },
                      {
                        key: "city",
                        fn: function(row) {
                          return [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  row.item.addresses
                                    .map(function(address) {
                                      return address.city
                                    })
                                    .join(", <br>")
                                )
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "postalCode",
                        fn: function(row) {
                          return [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  row.item.addresses
                                    .map(function(address) {
                                      return address.postalCode
                                    })
                                    .join(", <br>")
                                )
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "relation",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  row.item.relationshipType
                                    ? _vm.$t(
                                        "enums.relationTypes." +
                                          row.item.relationshipType
                                      )
                                    : null
                                ) +
                                "\n        "
                            )
                          ]
                        }
                      },
                      {
                        key: "street",
                        fn: function(row) {
                          return [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  row.item.addresses
                                    .map(function(address) {
                                      return address.street
                                    })
                                    .join(", <br>")
                                )
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "streetNumber",
                        fn: function(row) {
                          return [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  row.item.addresses
                                    .map(function(address) {
                                      return address.streetNumber
                                    })
                                    .join(", <br>")
                                )
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "actions",
                        fn: function(row) {
                          return [
                            _c("b-form-checkbox", {
                              attrs: { id: "heirCheckbox" },
                              on: {
                                change: function($event) {
                                  _vm.setHeirStatus($event, row.item.id)
                                }
                              },
                              model: {
                                value: row.item.heir,
                                callback: function($$v) {
                                  _vm.$set(row.item, "heir", $$v)
                                },
                                expression: "row.item.heir"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2861092a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2861092a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUserContactPerson.vue
// module id = Z/jf
// module chunks = 1